import React from 'react';
import { ReactComponent as IButton } from '../../icons/iButton.svg';
import { ReactComponent as DisabledIButton } from '../../icons/iButtonDisabled.svg';

export default function IButtonComponent({ disabled, onClick, style }) {
  style = { ...style, cursor: 'pointer' };
  if (disabled) return <DisabledIButton style={style} />;
  return <IButton style={style} onClick={onClick} />;
}
